import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from '../../components/Loader';
import { FEATURE_FLAGS } from '../../consts/features';
import { useSelfServeGate } from '../../hooks/billing/useSelfServeGate';
import { useFeatureAccess } from '../../hooks/useFeatureAccess';
import { useUser } from '../../hooks/useUser';
import { ROUTES } from '../consts';

export const BillingProtectedRoute = ({ children }: PropsWithChildren) => {
  const {
    isEnterpriseUser,
    isOrganizationOwner,
    isBillingDashboardEnabled,
    isTierScopedOwner,
  } = useUser();

  const { isEnabled: isBillingEnabled, isLoading: billingFlagLoading } =
    useFeatureAccess({
      featureId: FEATURE_FLAGS.BILLING,
    });

  const { isSelfServe, isLoading: selfServeLoading } = useSelfServeGate();

  if (billingFlagLoading || selfServeLoading) {
    return <Loader center />;
  }

  const canAccess = isEnterpriseUser
    ? isOrganizationOwner && isBillingDashboardEnabled
    : isTierScopedOwner && isBillingEnabled && isSelfServe;

  if (!canAccess) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  return <>{children}</>;
};
